import styled from 'styled-components';
import {
  CARD_BORDER_RADIUS_PX,
  CARD_PADDING_MOBILE_PX,
  CARD_PADDING_PX,
} from '../constants';
import { cardMobile } from '../utils';
import { CardHeaderStyleProps } from './types';

export const Root = styled.div<CardHeaderStyleProps>`
  border-top-left-radius: ${CARD_BORDER_RADIUS_PX}px;
  border-top-right-radius: ${CARD_BORDER_RADIUS_PX}px;
  padding: ${CARD_PADDING_PX}px ${CARD_PADDING_PX}px 0 ${CARD_PADDING_PX}px;
  position: relative;

  ${cardMobile`
    padding-left: ${CARD_PADDING_MOBILE_PX}px;
    padding-right: ${CARD_PADDING_MOBILE_PX}px;
  `}

  ${({ fullScreen }) => (!fullScreen ? undefined : `padding-top: 140px;`)}
`;

export const Action = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
`;

export const IconContainer = styled.div`
  margin-bottom: 30px;

  * {
    height: auto;
    width: 100px;
  }
`;

export const Icon = styled.div`
  margin-left: auto;
  margin-right: auto;
`;
